/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Nreviews1Inputs */

const en_nreviews1 = /** @type {(inputs: Nreviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} reviews)`)
};

const de_nreviews1 = /** @type {(inputs: Nreviews1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} Bewertungen)`)
};

/**
* | output |
* | --- |
* | "({count} reviews)" |
*
* @param {Nreviews1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nreviews1 = /** @type {((inputs: Nreviews1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nreviews1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nreviews1(inputs)
	return de_nreviews1(inputs)
});
export { nreviews1 as "nReviews" }